module.exports = __webpack_public_path__ + "img/icon_event.7869f35e.svg";